import { createContext, Dispatch, useContext } from 'react';
import { CommunicateEvent, CommunicateState } from './types';
import { initialState } from './reducer';

export const CommunicateContext = createContext<{
  state: CommunicateState;
  dispatch: Dispatch<CommunicateEvent>;
}>({
  state: initialState,
  dispatch: () => initialState,
});
export const useCommunicateContext = () => useContext(CommunicateContext);
